import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token:"",
    baseurl: process.env.VUE_APP_BASE_Res,
    currpage:0,
    ranks: []
  },
  getters: {
  },
  mutations: {
    setRanks(state, ranks) {
      state.ranks = ranks || []
    },
  },
  actions: {
  },
  modules: {
  }
})
